module.exports = __webpack_public_path__ + "media/partners/felgus@2x-62708dd7.png";